import { render, staticRenderFns } from "./SupplierRawMaterialFgAllocation.vue?vue&type=template&id=d5996592&"
import script from "./SupplierRawMaterialFgAllocation.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialFgAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports